import { mapActions } from 'vuex'
import setPWA from '../utils/pwa-utils'
import { getDeviceId } from '@src/utils/platformUtil.js'
export default {
  methods: {
    /**
     * Logout
     * @description It Calls logOut() from map actions, preserveDataAfterLogoutHandler()
     * and clearStates() to clear the values of fields and to logout from the system and returning to signin page
     */
    signOut() {
      let payload = {
        device_id: getDeviceId(),
      }
      this.logOut(payload)
      setTimeout(() => {
        this.clearStates()
      })
      this.destroyGeneralSettings()
      this.preserveDataAfterLogoutHandler()
      setPWA()
      this.$router?.push({ name: 'login' })
      if (this.$socket.isConnected()) {
        this.$socket.disconnect()
        this.$socket.channel = null
      }
      if (this.$apiSocketChannel?.isConnected()) {
        this.$apiSocketChannel.channels = []
        this.$apiSocketChannel.disconnect()
      }
      if (window.Tawk_API) window.Tawk_API.hideWidget()
    },

    /**
     * Clear States
     * @description It gives empty string to variables
     */
    clearStates() {
      let isTabView = this.$store.state.layout.isTabView
      this.$store.commit('layout/SET_SELECTED_CAMPUSE', '')
      this.$store.commit('layout/SET_CAMPUSES', [])
      this.$store.commit('layout/SET_CURRENT_SELECTED_CLASS_SCOPE', '')
      this.$store.commit('layout/SET_CURRENT_SELECTED_SECTION_SCOPE', '')
      this.$store.commit('layout/SET_SELECTED_ROLE', '')
      this.$store.commit('layout/SET_TAB_LEFT_BAR', !isTabView)
    },

    /**
     * Set Default Data After Lougout
     * @description Sets the default values when user logouts
     */
    preserveDataAfterLogoutHandler() {
      const preservedKeys = [
        'curLanguage',
        'theme',
        'pwaNextCheck',
        'notificationNextCheck',
        'hideDocumentationModal',
      ]

      const preservedData = {}

      preservedKeys.forEach((key) => {
        preservedData[key] = localStorage.getItem(key)
      })

      localStorage.clear()

      Object.entries(preservedData).forEach(([key, value]) => {
        if (value !== null) {
          localStorage.setItem(key, value)
        }
      })
    },
    ...mapActions('settings', ['destroyGeneralSettings']),
    ...mapActions('auth', ['logOut']),
  },
}
